/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

$.extend(true, $.fn.dataTable.defaults, {
  language:   {
    url: '/lang/de_DE.json'
  },
  dom:        "<'card-header' <'col-12 col-sm-6'l><'col-12 col-sm-6 mt-3 mt-sm-0 position-relative'fB>> <'table-responsive'rt> <'card-footer' <'row align-items-center'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 mt-2 mt-sm-0'p>>>",
  stateSave:  true,
  processing: true,
  serverSide: true,
  responsive: true,
  pageLength: 10,
  lengthMenu: [10, 20, 50, 100],
  buttons:    [
    {
      text:   '<i class="fa fa-times-circle"></i>',
      action: function (e, dt, node, config) {
        dt.search('').draw();
      }
    }
  ]
});

window.dataTable = null;
window.number_format = new Intl.NumberFormat('de-DE', {minimumFractionDigits: 2}); // TODO lang
window.date_format = {day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: '2-digit'};
window.lang = $('html').attr('lang');

window.empty = function (mixed_var) {
  let undef, i, len;
  let emptyValues = [undef, null, false, 0, "", "0"];

  for (i = 0, len = emptyValues.length; i < len; i++) {
    if (mixed_var === emptyValues[i]) {
      return true;
    }
  }

  return false;
}

window.select = function (parent) {
  if (parent === undefined) {
    parent = $('body');
  }

  $('.tom-select', parent).each(function (i, e) {
    new TomSelect('#' + e.id, {
      persist:               false,
      createOnBlur:          true,
      create:                true,
      copyClassesToDropdown: false,
      dropdownClass:         'dropdown-menu',
      optionClass:           'dropdown-item',
      controlInput:          '<input>',
      searchField:           ['text', 'prepend'],
      render:                {
        option: function (data, escape) {
          var $el = $('<span>' + escape(data.text) + '</span>');

          if (data.append) {
            $el.append('<span class="ms-2 px-2 bg-' + (data.color ?? 'dark') + '-lt">' + data.append + '</span>');
          } else if (data.color) {
            $el.addClass('px-2 bg-' + data.color + '-lt');
          }

          if (data.sub) {
            $el.append('<span class="d-block text-muted">' + data.sub + '</span>');
          }

          return $('<div>').html($el).prop('outerHTML');
        },
      }
    });
  });
}

Parsley.addMessages('de', {
  defaultMessage: "Die Eingabe scheint nicht korrekt zu sein.",
  type:           {
    email:    "Die Eingabe muss eine gültige E-Mail-Adresse sein.",
    url:      "Die Eingabe muss eine gültige URL sein.",
    number:   "Die Eingabe muss eine Zahl sein.",
    integer:  "Die Eingabe muss eine Zahl sein.",
    digits:   "Die Eingabe darf nur Ziffern enthalten.",
    alphanum: "Die Eingabe muss alphanumerisch sein."
  },
  notblank:       "Die Eingabe darf nicht leer sein.",
  required:       "Dies ist ein Pflichtfeld.",
  pattern:        "Die Eingabe scheint ungültig zu sein.",
  min:            "Die Eingabe muss größer oder gleich %s sein.",
  max:            "Die Eingabe muss kleiner oder gleich %s sein.",
  range:          "Die Eingabe muss zwischen %s und %s liegen.",
  minlength:      "Die Eingabe ist zu kurz. Es müssen min. %s Zeichen eingegeben werden.",
  maxlength:      "Die Eingabe ist zu lang. Es dürfen höchstens %s Zeichen eingegeben werden.",
  length:         "Die Länge der Eingabe ist ungültig. Es müssen zwischen %s und %s Zeichen eingegeben werden.",
  mincheck:       "Wählen Sie mindestens %s Angaben aus.",
  maxcheck:       "Wählen Sie maximal %s Angaben aus.",
  check:          "Wählen Sie zwischen %s und %s Angaben.",
  equalto:        "Dieses Feld muss dem anderen entsprechen."
});

Parsley.setLocale(lang);

Parsley.addValidator('minwords', {
  requirementType: 'string',
  validateString:  function (value, nbWords) {
    return value
      .replace(/(^\s*)|(\s*$)/gi, "")
      .replace(/\s+/gi, " ")
      .split(' ').length >= nbWords;
  },
  messages:        {
    en: 'This value must contain at least %s words.',
    de: 'Die Eingabe muss min. %s Wörter enthalten.'
  }
});

Parsley.addValidator('uppercase', {
  requirementType: 'number',
  validateString:  function (value, requirement) {
    let uppercases = value.match(/[A-Z]/g) || [];
    return uppercases.length >= requirement;
  },
  messages:        {
    en: 'The value must contain at least %s uppercase letter.',
    de: 'Die Eingabe muss min. %s Großbuchstaben enthalten.'
  }
});

Parsley.addValidator('lowercase', {
  requirementType: 'number',
  validateString:  function (value, requirement) {
    let lowecases = value.match(/[a-z]/g) || [];
    return lowecases.length >= requirement;
  },
  messages:        {
    en: 'The value must contain at least %s lowercase letter.',
    de: 'Die Eingabe muss min. %s Kleimnbuchstaben enthalten.'
  }
});

Parsley.addValidator('number', {
  requirementType: 'number',
  validateString:  function (value, requirement) {
    let numbers = value.match(/[0-9]/g) || [];
    return numbers.length >= requirement;
  },
  messages:        {
    en: 'The value must contain at least %s number/s.',
    de: 'Die Eingabe muss min. %s Ziffer/n enthalten.'
  }
});

Parsley.addValidator('special', {
  requirementType: 'number',
  validateString:  function (value, requirement) {
    let specials = value.match(/[^a-zA-Z0-9]/g) || [];
    return specials.length >= requirement;
  },
  messages:        {
    en: 'The value must contain at least %s special characters.',
    de: 'Die Eingabe muss min. %s Sonderzeichen enthalten.'
  }
});

Apex.chart = {
  locales:       [{
    "name":    "de",
    "options": {
      "months":      [
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
      ],
      "shortMonths": [
        "Jan",
        "Feb",
        "Mär",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
      ],
      "days":        [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
      ],
      "shortDays":   ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
      "toolbar":     {
        "exportToSVG":   "SVG speichern",
        "exportToPNG":   "PNG speichern",
        "exportToCSV":   "CSV speichern",
        "menu":          "Menü",
        "selection":     "Auswahl",
        "selectionZoom": "Auswahl vergrößern",
        "zoomIn":        "Vergrößern",
        "zoomOut":       "Verkleinern",
        "pan":           "Verschieben",
        "reset":         "Zoom zurücksetzen"
      }
    }
  }],
  defaultLocale: 'de'
}

$(function () {
  window.$modal = $('#defaultModal');

  // German
  $.timeago.settings.strings = {
    prefixAgo:     'vor',
    prefixFromNow: 'in',
    suffixAgo:     '',
    suffixFromNow: '',
    seconds:       'wenigen Sekunden',
    minute:        'etwa einer Minute',
    minutes:       '%d Minuten',
    hour:          'etwa einer Stunde',
    hours:         '%d Stunden',
    day:           'etwa einem Tag',
    days:          '%d Tagen',
    month:         'etwa einem Monat',
    months:        '%d Monaten',
    year:          'etwa einem Jahr',
    years:         '%d Jahren'
  };

  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
  });

  var clipboard = new ClipboardJS('.btn-clip');

  clipboard.on('success', function (e) {
    $(e.trigger).tooltip({trigger: 'manual'}).tooltip('show');
    setTimeout(function () {
      $(e.trigger).tooltip('hide');
    }, 600);

    e.clearSelection();
  });

  $(document).on('click', '[data-bs-toggle="modal-ajax"]', function (e) {
    e.preventDefault();
    $modal.load($(this).attr('href'), function (response, status) {
      if (status === "success") {
        $(this).modal('show');
      }
    });
  });

  $modal.on('show.bs.modal', function () {
    select($(this));
  });

  select();
});
